import { ManageInsightsPeriodPreset, ManageInsightsWindowKey } from '@/gql/reviews'

export enum InsightsTimeframe {
  LATEST = 'latest',
  LAST_3_MONTHS = 'last-3-months',
  LAST_6_MONTHS = 'last-6-months',
  LAST_12_MONTHS = 'last-12-months',
  YTD = 'ytd',
}

export const DEFAULT_INSIGHTS_TIMEFRAME = InsightsTimeframe.LAST_12_MONTHS

const PERIOD_PRESET_BY_TIMEFRAME: Record<InsightsTimeframe, ManageInsightsPeriodPreset> = {
  [InsightsTimeframe.LATEST]: ManageInsightsPeriodPreset.Latest,
  [InsightsTimeframe.LAST_3_MONTHS]: ManageInsightsPeriodPreset.Last_3Months,
  [InsightsTimeframe.LAST_6_MONTHS]: ManageInsightsPeriodPreset.Last_6Months,
  [InsightsTimeframe.LAST_12_MONTHS]: ManageInsightsPeriodPreset.Last_12Months,
  [InsightsTimeframe.YTD]: ManageInsightsPeriodPreset.Ytd,
}

export const timeframeToPeriodPreset = (timeframe: InsightsTimeframe): ManageInsightsPeriodPreset => PERIOD_PRESET_BY_TIMEFRAME[timeframe]

const WINDOW_KEY_BY_TIMEFRAME: Record<InsightsTimeframe, ManageInsightsWindowKey> = {
  [InsightsTimeframe.LATEST]: ManageInsightsWindowKey.Latest,
  [InsightsTimeframe.LAST_3_MONTHS]: ManageInsightsWindowKey.Last_3Months,
  [InsightsTimeframe.LAST_6_MONTHS]: ManageInsightsWindowKey.Last_6Months,
  [InsightsTimeframe.LAST_12_MONTHS]: ManageInsightsWindowKey.Last_12Months,
  [InsightsTimeframe.YTD]: ManageInsightsWindowKey.Ytd,
}

export const timeframeToWindowKey = (timeframe: InsightsTimeframe): ManageInsightsWindowKey => WINDOW_KEY_BY_TIMEFRAME[timeframe]
